module.exports = __webpack_public_path__ + "img/new_platform.27887441.png";